<template>
  <div class="container">
    <div class="title">
      <h4>Сравнительный анализ категории <span>(базовый)</span></h4>
    </div>
    <div class="content">
      <div class="select-block"
           :style="{display:selectedCategories?selectedCategories.length?'grid':'flex':'flex',
           justifyContent:selectedCategories?selectedCategories.length?'unset':'space-between':'space-between'}"
      >
        <selection-block-category

            :getCategory="getSelectedCategories"
            :getLocationsData="getLocationsData"
        />
        <my-date-period-picker-analytics
            :getTime="getStartEndTimeForGetCategoryCalls"
        />
      </div>
      <div class="statistic-block">
        <statistic-block
            :loading="loading"
            :locationsData="locationsData"
            :propsData="allDataCategoryApi"
        />
      </div>
    </div>


  </div>
</template>

<script>


import MyDatePeriodPickerAnalytics from "@/components/analytics/basicCategoryAnalysis/myDatePeriodPickerAnalytics.vue";
import SelectionBlockCategory from "@/components/analytics/basicCategoryAnalysis/SelectionBlockCategory.vue";
import StatisticBlock from "@/components/analytics/basicCategoryAnalysis/statisticBlock/statisticBlock.vue";


export default {
  name: "BasicCategoryAnalysis",
  components: {StatisticBlock, SelectionBlockCategory, MyDatePeriodPickerAnalytics},

  data() {
    return {
      loading: false,
      startEndDateForCallListAndCategoryDictionaries: {start: '', end: ''},
      selectedCategories: null,
      allDataCategoryApi: [],
      locationsData: []

    }
  },
  methods: {
    getLocationsData(callback) {
      return this.locationsData = callback
    },
    getStartEndTimeForGetCategoryCalls(callback) {
      this.startEndDateForCallListAndCategoryDictionaries = callback
    },
    getCategoryDictionaries(id) {
      this.loading = true;
      this.$api.category.getCategoryDictionaries({
        category_id: id,
        date_start: this.startEndDateForCallListAndCategoryDictionaries.start ? this.startEndDateForCallListAndCategoryDictionaries.start : '',
        date_end: this.startEndDateForCallListAndCategoryDictionaries.end ? this.startEndDateForCallListAndCategoryDictionaries.end : '',
      })
          .then(data => {
            let allDataCategoryApi = [...this.allDataCategoryApi]
            allDataCategoryApi.find((item => item.id === id)).dictionaries = data
            this.allDataCategoryApi = allDataCategoryApi
            this.getCategoryDictionariesFullData()
          })
          .finally(() => {
            this.loading = false;
          })
    },
    getCategoryDictionariesFullData() {
      this.loading = true;
      this.allDataCategoryApi.forEach((item, index) => {
        console.log(item)
        if(item.dictionaries) {
          item.dictionaries.system.forEach((dict, idx) => {
            this.$api.category.getCategoryDictionaryFullData({
              category_id: dict.category_id,
              dictionary_id: dict.dictionary_id,
              with_data: 1,
              dictionary_type:'system',
              date_start: this.startEndDateForCallListAndCategoryDictionaries.start ? this.startEndDateForCallListAndCategoryDictionaries.start : '',
              date_end: this.startEndDateForCallListAndCategoryDictionaries.end ? this.startEndDateForCallListAndCategoryDictionaries.end : '',
            })
                .then(data => {
                  data.dictionary_type = "system";
                  this.allDataCategoryApi[index].dictionaries.system[idx] = data
                })
                .finally(() => {
                  this.loading = false;
                })
          })

          item.dictionaries.client.forEach((dict, idx) => {
            this.$api.category.getCategoryDictionaryFullData({
              category_id: dict.category_id,
              dictionary_id: dict.dictionary_id,
              with_data: 1,
              dictionary_type:'client',
              date_start: this.startEndDateForCallListAndCategoryDictionaries.start ? this.startEndDateForCallListAndCategoryDictionaries.start : '',
              date_end: this.startEndDateForCallListAndCategoryDictionaries.end ? this.startEndDateForCallListAndCategoryDictionaries.end : '',
            })
                .then(data => {
                  data.dictionary_type = "client";
                  this.allDataCategoryApi[index].dictionaries.client[idx] = data
                })
                .finally(() => {
                  this.loading = false;
                })
          })
        }


      })


    },
    getCategoryRecognizedCalls(id) {
      this.loading = true;
      this.$api.category.getCategoryRecognizedCalls({
        category_id: id,
        date_start: this.startEndDateForCallListAndCategoryDictionaries.start,
        date_end: this.startEndDateForCallListAndCategoryDictionaries.end,
      })
          .then(data => {
            let allDataCategoryApi = [...this.allDataCategoryApi]
            allDataCategoryApi.find((item => item.id === id)).calls = data
            this.allDataCategoryApi = allDataCategoryApi
          })
          .finally(() => {
            this.loading = false;
          })
    },
    getCategoryChecklists(id) {
      this.loading = true;
      this.$api.category.getCategoryChecklists({
        category_id: id,
        date_start: this.startEndDateForCallListAndCategoryDictionaries.start ? this.startEndDateForCallListAndCategoryDictionaries.start : '',
        date_end: this.startEndDateForCallListAndCategoryDictionaries.end ? this.startEndDateForCallListAndCategoryDictionaries.end : '',
      })
          .then(data => {
            let allDataCategoryApi = [...this.allDataCategoryApi]
            allDataCategoryApi.find((item => item.id === id)).checklist = data
            this.allDataCategoryApi = allDataCategoryApi
            this.getChecklistAnalytics(id)
          })
          .finally(() => {
            this.loading = false;
          })
    },
    getChecklistAnalytics(id) {
        this.$api.category.getCategoryChecklistAnalytics({
          category_id: id,
          date_start: this.startEndDateForCallListAndCategoryDictionaries.start ? this.startEndDateForCallListAndCategoryDictionaries.start : '',
          date_end: this.startEndDateForCallListAndCategoryDictionaries.end ? this.startEndDateForCallListAndCategoryDictionaries.end : '',
        })
            .then(data => {
              let allDataCategoryApi = [...this.allDataCategoryApi]
              allDataCategoryApi.find((item => item.id === id)).checklist = data
              this.allDataCategoryApi = allDataCategoryApi
            })
    },
    getSelectedCategories(callBack) {
      this.selectedCategories = callBack
    },
    getCategoryApi(id) {
      this.$api.category.getCategory({
        category_id: id
      })
          .then((data) => {
            this.allDataCategoryApi = [...this.allDataCategoryApi, data]
            this.getCategoryRecognizedCalls(id)
            this.getCategoryChecklists(id)
            this.getCategoryDictionaries(id)
          })
          .finally(() => {
          })
    },
  },
  watch: {
    selectedCategories() {
      this.allDataCategoryApi = []
      this.selectedCategories.forEach(id => {
        this.getCategoryApi(id)
      })
    },
    startEndDateForCallListAndCategoryDictionaries() {
      this.allDataCategoryApi = []
      if (this.selectedCategories && this.selectedCategories) {
        this.selectedCategories.forEach(id => {
          this.getCategoryApi(id)
        })
      }

    },
    allDataCategoryApi() {

    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  padding: 15px;
  min-height: 85vh;
  border-right: 10px;

  .title {
    margin-bottom: 30px;

    h4 {
      margin-bottom: 0px;
      font-size: 18px;
      font-weight: 700;
      color: #555;

      span {
        font-weight: normal;
        font-size: 14px;
      }
    }
  }

  .content {
    padding: 15px;
    box-shadow: 0 2px 4px rgb(0 0 0 / 12%), 0 0 6px rgb(0 0 0 / 4%);
    border-radius: 10px;
    background: #fff;
    min-height: 75vh;

    .select-block {
      display: flex;
      //align-items: center;
      justify-content: space-between;
      gap: 10px;
      .wrapp{
        display: flex ;
      }

    }
  }
}

::v-deep {
  .el-input__inner {
    height: 30px;
  }

  .el-input__suffix {
    i {
      line-height: 1;
    }
  }
}
</style>